import { httpsCallable } from 'actions/firebase/functions'

const payBooking = async (bookingId, query, gateway) => httpsCallable('payBooking', { bookingId, query, gateway })

export default payBooking
